import { Box, IconButton, Icon, Tooltip } from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import React from "react";
import SidebarContent from "./SidebarContent";
import { useAppContext } from "context/appContext";
import { SIDEBAR_W_EXPANDED, SIDEBAR_W_COLLAPSED } from "./sidebarSize";

function Sidebar() {
  const { sidebarCollapsed, toggleSidebarCollapsed } = useAppContext();
  const width = sidebarCollapsed ? SIDEBAR_W_COLLAPSED : SIDEBAR_W_EXPANDED;

  return (
    <Box
      display={{ base: "none", xl: "block" }}
      position="fixed"
      left="0"
      top="0"
      w={`${width}px`}
      h="100vh"
      bg="#231E1A"
      px={sidebarCollapsed ? "10px" : "16px"}
      py="24px"
      zIndex="1000"
      transition="width .18s ease, padding .18s ease"
    >
      {/* Pestaña de colapsar/expandir — mismo lenguaje visual que el botón
          del panel de historial del escáner (círculo pequeño, borde
          visible, mitad afuera del borde del sidebar para que se note y se
          pueda tocar desde cualquiera de los dos estados). */}
      <Tooltip label={sidebarCollapsed ? "Expandir menú" : "Colapsar menú"} placement="right">
        <IconButton
          icon={<Icon as={sidebarCollapsed ? FiChevronRight : FiChevronLeft} boxSize="16px" />}
          aria-label={sidebarCollapsed ? "Expandir menú" : "Colapsar menú"}
          onClick={toggleSidebarCollapsed}
          position="absolute" top="28px" right="-14px"
          w="28px" h="28px" minW="28px" borderRadius="full"
          bg="#231E1A" color="#B8ABA1" border="1.5px solid" borderColor="#3A332C"
          _hover={{ bg: "coral.500", color: "#fff", borderColor: "coral.500" }}
          zIndex="1001"
        />
      </Tooltip>
      <SidebarContent collapsed={sidebarCollapsed} />
    </Box>
  );
}

export default Sidebar;
